import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { HubFooter } from '../../templates';

/**
 * The footer section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class HubFooterView extends Component {

	render () {

		const { content } = this.props.content.landingPage.footer;

		return (
			<HubFooter
				{...{
					content,
				}}
			/>
		);
	}

}

export default withLanguageContext(HubFooterView);



// WEBPACK FOOTER //
// ./src/components/views/HubFooterView/HubFooterView.js